import { ModalHeader, ModalView, useModalView } from '@/design-system/components/modal';
import { useTranslation } from 'react-i18next';
import { SxProp, View } from 'dripsy';
import { AccountManagementStackRoutes, AccountManagementStackScreenProps } from '../../account.navigator';
import { UniButton } from '@/design-system/components/buttons';
import { ButtonVariant } from '@/design-system/components/buttons/useButton.hook';
import { TextCaption, TextTitle } from '@/design-system/components/typography';
import { keyGenerator } from '@/utils/keyGenerator';

export interface TransactionInfoWebProps {
  xmetadata: { [key: string]: any };
}
export const TransactionInfoWebScreen: React.FC<TransactionInfoWebProps> = ({ xmetadata }) => {
  const { useModalProps, closeModal } = useModalView({});
  const { t } = useTranslation('account-management');
  const { topHeader, body } = sxStyles;

  return (
    <ModalView useModalProps={useModalProps} minWidth={500}>
      <View>
        <View sx={topHeader}>
          <ModalHeader title={t('card-account-management::card-details.text--view-xmetadata')} closeModal={closeModal} />
        </View>
        <View sx={body}>
          <View sx={{ flex: 1, flexDirection: 'column', justifyContent: 'space-between' }}>
            <View sx={{ flexDirection: 'column', gap: '$3' }}>
              {Object.keys(xmetadata).map((key) => (
                <View key={keyGenerator(key + '-transaction')} sx={{ flexDirection: 'column', gap: '$1' }}>
                  <TextTitle semiBold>{key}:</TextTitle>
                  <TextCaption>{xmetadata[key]}</TextCaption>
                </View>
              ))}
            </View>
            <UniButton
              variant={ButtonVariant.outline1}
              sx={{ width: '100%', height: 44 }}
              label={t('card-account-management::general.button--close')}
              onPress={closeModal}
            />
          </View>
        </View>
      </View>
    </ModalView>
  );
};

const sxStyles: Record<string, SxProp> = {
  topHeader: {
    height: 70,
    justifyContent: 'center'
  },
  body: {
    minHeight: 200,
    minWidth: 500,
    px: 28,
    py: 28
  }
};
